module.exports = __webpack_public_path__ + "static/media/bread-slice.8f2c1855.svg";